// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4288":"0a92878a","9242":"6bc69632"}[chunkId] + ".chunk.css";
};